//import { calculateTotalInterest, calculateRepayments } from 'backend/calculator.web';
import { getRates, calculate } from 'backend/loanCalculations.jsw';

// Define loan parameters
const MIN_LOAN_AMOUNT = 2000; // Should pull this from Product Table
const MAX_LOAN_AMOUNT = 100000; // Should pull this from Product Table
const DEFAULT_LOAN_AMOUNT = 30000;
var currSelectedLoanTerm = null;
var currSelectedRepaymentFrequency = null;
var currSelectedCreditHistory = null;

$w.onReady(function () {
    const loanAmountInput = $w("#inputLoanAmount");
    loanAmountInput.value = `$${DEFAULT_LOAN_AMOUNT.toLocaleString()}`;
    $w('#textLoanAmountText').text = `You can apply to borrow $${MIN_LOAN_AMOUNT} - $${MAX_LOAN_AMOUNT}`

    //Retrieve initial state of buttons - so we can ensure one is always selected.
    const selectionLoanTerm = $w("#selectionLoanTerm");
    currSelectedLoanTerm = selectionLoanTerm.options[0].value;

    const selectionRepaymentFrequency = $w("#selectionRepaymentFrequency");
    currSelectedRepaymentFrequency = selectionRepaymentFrequency.options[0].value;

    const selectionCreditHistory = $w("#selectionCreditHistory");
    currSelectedCreditHistory = selectionCreditHistory.options[0].value;

    //Recalculate 
    calculateRepayment();
});
function manageLoanAmount() {
    //get current values from page
    const loanInput = $w("#inputLoanAmount");
    const inputValue = loanInput.value; // Get the user input
    let numericValue = parseFloat(inputValue.replace(/[^0-9.]/g, '')); // Remove $ and commas + leaving decimal
    numericValue = Math.floor(numericValue);

    if (!isNaN(numericValue)) {
        if (numericValue > MAX_LOAN_AMOUNT) {
            numericValue = MAX_LOAN_AMOUNT; //Reset to largest
        } else if (numericValue < MIN_LOAN_AMOUNT) {
            numericValue = MIN_LOAN_AMOUNT; //Reset to smallest
        }
    } else {
        numericValue = DEFAULT_LOAN_AMOUNT; //reset to default
    }
    // Format the number as currency and set it back to the input
    const formattedValue = `$${numericValue.toLocaleString()}`;
    loanInput.value = formattedValue;

    calculateRepayment();
}

//Fire on change
$w('#inputLoanAmount').onChange((event) => {
    manageLoanAmount();
});

//Fire on Enter key pressed
$w('#inputLoanAmount').onKeyPress((event) => {
    if (event.key === 'Enter') {
        const inputValue = $w('#inputLoanAmount').value;
        //console.log("Enter key pressed. Final value:", inputValue);
        manageLoanAmount();
    }
});

$w('#selectionLoanTerm').onChange(() => {
    const selectionLoanTerm = $w("#selectionLoanTerm");
    var selectedTags = selectionLoanTerm.value;

    // Check if more than one tag is selected
    if (!selectedTags || selectedTags.length == 0) {
        //console.log("Prevented unselecting all tags. Reverting to previous selection => " + currSelectedLoanTerm );
        // Revert to the last valid value
        selectionLoanTerm.value = currSelectedLoanTerm;
    } else if (selectedTags.length > 1) {
        // Keep only the last selected tag by setting the value to that single tag
        //console.log("More than one Selected - selecting new one");
        selectionLoanTerm.value = [selectedTags[selectedTags.length - 1]];
        currSelectedLoanTerm = selectionLoanTerm.value;
    }

    calculateRepayment();
});

$w('#selectionCreditHistory').onChange(() => {
    const selectionCreditHistory = $w("#selectionCreditHistory");
    var selectedTags = selectionCreditHistory.value;

    // Check if more than one tag is selected
    if (!selectedTags || selectedTags.length == 0) {
        //console.log("Prevented unselecting all tags. Reverting to previous selection => " + currSelectedCreditHistory );
        // Revert to the last valid value
        selectionCreditHistory.value = currSelectedCreditHistory;
    } else if (selectedTags.length > 1) {
        // Keep only the last selected tag by setting the value to that single tag
        //console.log("More than one Selected - selecting new one");
        selectionCreditHistory.value = [selectedTags[selectedTags.length - 1]];
        currSelectedCreditHistory = selectionCreditHistory.value;
    }

    calculateRepayment();
});
$w('#selectionRepaymentFrequency').onChange(() => {
    const selectionRepaymentFrequency = $w("#selectionRepaymentFrequency");
    var selectedTags = selectionRepaymentFrequency.value;

    // Check if more than one tag is selected
    if (!selectedTags || selectedTags.length == 0) {
        //console.log("Prevented unselecting all tags. Reverting to previous selection => " + currSelectedRepaymentFrequency );
        // Revert to the last valid value
        selectionRepaymentFrequency.value = currSelectedRepaymentFrequency;
    } else if (selectedTags.length > 1) {
        // Keep only the last selected tag by setting the value to that single tag
        //console.log("More than one Selected - selecting new one");
        selectionRepaymentFrequency.value = [selectedTags[selectedTags.length - 1]];
        currSelectedRepaymentFrequency = selectionRepaymentFrequency.value;
    }
    calculateRepayment();
});

// Function to calculate and display the repayment amount
function calculateRepayment() {
    //get current values from page
    const loanInput = $w("#inputLoanAmount");
    const rawValue = loanInput.value; // Get the formatted value (e.g., "$20,000")
    const loanAmount = parseFloat(rawValue.replace(/[^0-9]/g, '')); // Remove $ and commas
    const currRepaymentFrequency = $w("#selectionRepaymentFrequency").value[0]; // ["weekly"]
    const currCreditHistory = $w("#selectionCreditHistory").value[0]; // ["average"]
    const currTermYears = parseInt($w("#selectionLoanTerm").value[0]); // Get the selected term in years

    calculate(loanAmount, currTermYears, currRepaymentFrequency, currCreditHistory)
        .then(result => {

            //console.log(`------------------------------------------`);
            //console.log(`Annual Rate: ${result.annualRate}%`);
            //console.log(`Estab Fee: ${result.estabFee}`);
            //console.log(`FrequencyMessage: ${result.frequencyMessage}`);
            //console.log(`Comparison Rate: ${result.comparisonRate}`);
            //console.log(`Repayment Per Period: $${result.repaymentPerPeriod}`);
            //console.log(`Total Interest Paid: $${result.totalInterest}`);

            $w("#textPeriodAmount").text = `$${result.repaymentPerPeriod}`;
            $w("#textRepaymentFrequencyText").text = result.frequencyMessage
            //$w("#textInterestRates").text = `Interest rate ${result.annualRate}% (comparison rate ${result.comparisonRate}%)`;
            $w("#textInterestRates").text = `Interest rate ${result.annualRate}%`;
            //$w('#textSummary').text = `Estimate includes establishment fee of $${result.estabFee} and interest charges totalling $${result.totalInterest}`;
            $w('#textSummary').text = `Estimate includes establishment fee of $${result.estabFee}`;
        })
        .catch(error => {
            console.error("Error calculating:", error);
        });
}